export default __webpack_public_path__ + "static/media/Hand-wraps of the Nebulous.c3b2c861.jpg";